import type { CalendarComposePriorStateConfig } from 'owa-calendar-compose-types';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getId } from '@fluentui/react/lib/Utilities';
import { addComposeStore, setOriginalEvent, setEvent } from 'owa-calendar-compose-store-manager';
import { internalShowFullCompose } from './showFullCompose';
import { fetchFullCalendarEventAndUpdateItemResponseShapeType } from 'owa-calendar-forms-common/lib/helpers/eventStore';
import cloneDeep from 'lodash-es/cloneDeep';

/**
 * Show full compose in popout window from prior state (legacy behavior)
 */
export async function showFullComposeFromPriorState(
    config: CalendarComposePriorStateConfig
): Promise<string | null> {
    const {
        viewState,
        event,
        originalEvent,
        composeEntrySource,
        shouldOpenSchedulingAssistant,
    } = config;

    let formId = getId('CalendarCompose_');
    addComposeStore(formId);

    if (event.ItemId?.Id) {
        fetchFullCalendarEventAndUpdateItemResponseShapeType(
            event.ItemId,
            'WithBlockedExternalContent',
            null,
            () =>
                // in most situations, we want to pass the actual item here, rather than a deep clone, because loading the full item from the
                // cache will overwrite the partial item's properties. However, in this case, we're passing the UPDATED item as the partial item
                // which we don't want the properties to be overwritten for because we'll lose those updates.
                cloneDeep(event) as CalendarEvent /* getExistingCalendarEvent */,
            undefined /* isfetchFullSeriesMasterCalendarEventFromEventInstance */,
            { fetchSource: 'showFullComposeForLegacyPopout' }
        );
    }

    setOriginalEvent(formId, originalEvent);
    setEvent(formId, event);

    await internalShowFullCompose(
        formId,
        viewState,
        composeEntrySource,
        undefined /* extractionSourceId */,
        shouldOpenSchedulingAssistant
    );

    return formId;
}
